module.exports = __webpack_public_path__ + "static/media/ic_view.3f45a0ea.svg";